import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { TbShoppingCartCopy } from 'react-icons/tb';
import { FiChevronRight } from 'react-icons/fi';
import Boutton from '../../components/Boutton/Boutton';
import Sectionbureau from '../../components/Sectionbureau/Sectionbureau';
import '../../styles/categoryPage.css';
import '../../styles/productDetail.css';

const ChaiseDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [related, setRelated] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setProduct(null);
    setRelated([]);
    setQuantity(1);
    setIsImageLoaded(false);
    setNotFound(false);

    axios.get(`${process.env.REACT_APP_API_URL}/chaise/${id}/lister`).then(res => {
      if (cancelled) return;
      const data = res.data;
      setProduct(data);
      axios.get(`${process.env.REACT_APP_API_URL}/chaise/lister`).then(res2 => {
        if (cancelled) return;
        const others = res2.data.filter(p => p._id !== data._id);
        const sameType = others.filter(p => p.type === data.type);
        setRelated(sameType.length > 0 ? sameType : others);
      }).catch(() => {});
    }).catch(() => {
      if (!cancelled) setNotFound(true);
    });

    return () => { cancelled = true };
  }, [id]);

  if (notFound) {
    return (
      <Container className="detail-page">
        <div className="hd-catpage-empty">
          <p>Ce produit est introuvable ou a été retiré.</p>
          <Link to="/Chaise">Retour aux chaises</Link>
        </div>
      </Container>
    );
  }

  if (!product) {
    return (
      <Container className="detail-page">
        <Row className="detail-main g-4">
          <Col lg={6}>
            <div className="hd-skeleton-media detail-skeleton-image" />
          </Col>
          <Col lg={6}>
            <div className="hd-skeleton-line detail-skeleton-title" />
            <div className="hd-skeleton-line detail-skeleton-row hd-skeleton-line-sm" />
            <div className="hd-skeleton-line detail-skeleton-row" style={{ marginTop: 24 }} />
            <div className="hd-skeleton-line detail-skeleton-row" />
            <div className="hd-skeleton-line detail-skeleton-row hd-skeleton-line-lg" />
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="detail-page">
      <motion.nav
        className="hd-breadcrumb"
        aria-label="breadcrumb"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <Link to="/">Accueil</Link>
        <FiChevronRight />
        <Link to="/Chaise">Chaise</Link>
        <FiChevronRight />
        <span>{product.titre}</span>
      </motion.nav>

      <Row className="detail-main g-4">
        <Col lg={6} className="detail-image-column">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="detail-image-container"
          >
            <img
              src={product.image}
              alt={product.titre}
              className={`detail-main-image ${isImageLoaded ? 'loaded' : ''}`}
              onLoad={() => setIsImageLoaded(true)}
            />
          </motion.div>
        </Col>

        <Col lg={6} className="detail-content-column">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="detail-content"
          >
            <h1 className="detail-title">{product.titre}</h1>
            <p className="detail-reference">Réf. {product.reference}</p>

            <div className="detail-price-container">
              <h2 className="detail-price">{product.prix * quantity} DT</h2>
              <div className={`detail-availability ${product.disponibilite === 'En stock' ? 'in-stock' : 'out-of-stock'}`}>
                {product.disponibilite}
              </div>
            </div>

            <div className="detail-short-desc" dangerouslySetInnerHTML={{ __html: product.description }} />

            <div className="detail-quantity-container">
              <div className="detail-quantity-box">
                <button onClick={() => quantity > 1 && setQuantity(quantity - 1)} className="detail-quantity-btn">-</button>
                <span className="detail-quantity-value">{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)} className="detail-quantity-btn">+</button>
              </div>
              <div className="detail-btn-container">
                <Boutton
                  item={product}
                  price={product.prix}
                  quantite={quantity}
                />
              </div>
            </div>

            <div className='detail-contact-line'>
              <TbShoppingCartCopy className='detail-contact-icon' />
              <p className='detail-contact-text'>
                Appelez-nous au <a href={process.env.REACT_APP_TEL2} className='detail-contact-link'>{process.env.REACT_APP_TEL}</a>
              </p>
            </div>
          </motion.div>
        </Col>
      </Row>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="detail-full-description"
      >
        <span className="detail-section-eyebrow">Le détail</span>
        <h4 className="detail-section-title">Description complète</h4>
        <div className="detail-full-description-body" dangerouslySetInnerHTML={{ __html: product.description2 }} />
      </motion.div>

      {related.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="detail-related"
        >
          <span className="detail-section-eyebrow">À découvrir aussi</span>
          <h4 className="detail-section-title">Produits similaires</h4>
          <Row className="g-4">
            {related.map(info => (
              <Col key={info._id} lg={3} md={4} sm={6}>
                <Sectionbureau nom={info.nom} titre={info.titre} prix={info.prix} image={info.image} id={info._id} />
              </Col>
            ))}
          </Row>
        </motion.div>
      )}
    </Container>
  );
};

export default ChaiseDetails;
